import { FC } from 'react';
import { AppMenuWraperProps } from './types';
import { useStyles } from './styles';
import AppMenu from 'components/AppMenu';

export const AppMenuWraper: FC<AppMenuWraperProps> = ({ show, title, extraInfo = '', children }) => {
  const classes = useStyles();
  return (
    <div className={show ? classes.appMenuWraper : ''}>
      {show ? <AppMenu title={title as string} additionalDescription={extraInfo} /> : null}
      <main className={show ? classes.main : ''}>{children}</main>
    </div>
  );
};
